const TZ = "Europe/Berlin";
const fmt = new Intl.DateTimeFormat("en-GB", { timeZone: TZ, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
const parts = (d) => Object.fromEntries(fmt.formatToParts(d).map((p) => [p.type, p.value]));
const offsetMs = (d) => { const p = parts(d); return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(d.getTime() / 1000) * 1000; };

export const berlin = (iso, { date = false } = {}) => (iso ? new Date(iso).toLocaleString("de-DE", { timeZone: TZ, weekday: "short", day: "2-digit", month: "2-digit", year: "numeric", ...(date ? {} : { hour: "2-digit", minute: "2-digit" }) }) : "");
export const tzLabel = (iso) => (offsetMs(new Date(iso)) >= 7200000 ? "CEST" : "CET");
export const isIsoDateTime = (v) => typeof v === "string" && /^\d{4}-\d\d-\d\dT\d\d:\d\d/.test(v);

export const toBerlinInput = (iso) => {
  if (!iso) return "";
  const p = parts(new Date(iso));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};

export const fromBerlinInput = (v) => {
  if (!v) return "";
  const guess = new Date(`${v}:00Z`);
  const t = guess.getTime() - offsetMs(guess);
  return new Date(guess.getTime() - offsetMs(new Date(t))).toISOString();
};
